import React from "react";
import Layout, { LAYOUT_QUERY } from "@/components/Layout";

import { RootState } from "@/store/store";
import { RADIO_STATE } from "@/store/liveRadio/action";
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchAPI } from "@/utils/api/api";

import Link from "next/link";
import { GRAPHQL_STRAPI_IMAGE } from "@/components/StrapiProgressiveImage";
import { StrapiImage } from "typings/strapi";

import BlogPage, { GET_BLOG_POSTS_QUERY } from "@/components/BlogPage";

require("@/styles/blog.less");

const ITEMS_PER_PAGE = 10;

const BlogIndex = ({ graphQLData, totalPageNum }) => {
  return (
    <BlogPage
      graphQLData={graphQLData}
      currentPageNum={1}
      totalPageNum={totalPageNum}
    />
  );
};

const mapState = (state: RootState) => ({});

export async function getStaticProps() {
  const data = await fetchAPI(GET_BLOG_POSTS_QUERY(1));

  return {
    props: {
      graphQLData: data,
      currentPageNum: 1,
      totalPageNum: Math.ceil(
        (data?.articlesConnection?.aggregate?.totalCount || 10) / ITEMS_PER_PAGE
      ),
    },
    revalidate: 1,
  };
}

const connector = connect(mapState);

export default compose(connector)(BlogIndex);
